var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.signInWithMicrosoft}},[_vm._v("Sign in with Microsoft")])])
}
var staticRenderFns = []

export { render, staticRenderFns }